import React from 'react';
import PropTypes from 'prop-types';
import CarouselItem from '../Carousel/CarouselItem';
import RelatedItemPrice from '../RelatedItemPrice/RelatedItemPrice';
import RelatedItemDiscount from '../RelatedItemPrice/RelatedItemDiscount';
import { trackProductImpressions } from '../../actions/pdpTrackingActions';

class SimilarItem extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { item, position, itemIsUnavailable } = this.props;
        const name = itemIsUnavailable ? 'sold pdp' : 'pdp';
        const listName = `${name} browse similar items`;
        this.context.executeAction(trackProductImpressions, { product: item, position, listName });
    }

    render() {
        const { item, onClick, position, currency } = this.props;
        const { priceUI, creator, vertical } = item;

        return (
            <div className="colLg2 colMd4 colXs6 pdp-similar-item-wrapper">
                <div className="pdp-similar-item">
                    <a href={item.uri} className="pdp-similar-item-link" onClick={onClick}>
                        <CarouselItem
                            className="pdp-similar-item-image"
                            title={item.title}
                            src={item.image}
                            index={position}
                        />
                        <div className="pdp-similar-item-text">
                            <div className="pdp-similar-item-title">
                                {vertical === 'art' && creator && `${creator} - `}
                                {item.title}
                            </div>
                            <div className="pdp-similar-item-price">
                                <RelatedItemPrice priceUI={priceUI} currency={currency} />
                                <RelatedItemDiscount priceUI={priceUI} />
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}

SimilarItem.contextTypes = {
    executeAction: PropTypes.func,
};

SimilarItem.propTypes = {
    position: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    itemIsUnavailable: PropTypes.bool,
    currency: PropTypes.string,
};

module.exports = SimilarItem;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/SimilarItem.jsx